import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { Provider } from "react-redux";
import { store } from "./store/store.js";

// Early route prefetch for blog if visiting /blog
if (typeof window !== "undefined" && window.location.pathname.startsWith("/blog")) {
  import("./pages/Blog");
}

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>,
);

// Defer PWA Service Worker registration until after load / idle
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    const registerPwa = () => {
      import("virtual:pwa-register").then(({ registerSW }) => {
        registerSW({ immediate: true });
      });
    };

    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(registerPwa);
    } else {
      setTimeout(registerPwa, 1200);
    }
  });
}

